import request from 'sb-request'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'
import { constants } from 'common/helpers'


const showRequestLoader = () => {
  const { models: { ui: { isRequestLoaderVisible } } } = getState()

  if (!isRequestLoaderVisible) {
    reducers.models.ui.setRequestLoaderVisibility(true)
  }
}

const hideRequestLoader = () => {
  const { models: { ui: { isRequestLoaderVisible } } } = getState()

  if (isRequestLoaderVisible) {
    reducers.models.ui.setRequestLoaderVisibility(false)
  }
}

const setLocale = (locale) => reducers.models.ui.setLocale(locale)

const openSideMenu = () => {
  reducers.models.ui.setProfileMenuVisibility(false)
  reducers.models.ui.setSideMenuVisibility(true)
}
const closeSideMenu = () => reducers.models.ui.setSideMenuVisibility(false)

const openProfileMenu = () => {
  reducers.models.ui.setProfileMenuVisibility(true)
  reducers.models.ui.setSideMenuVisibility(false)
}
const closeProfileMenu = () => reducers.models.ui.setProfileMenuVisibility(false)

const toggleHeaderDropMenuVisibility = (dropMenuName) => {
  const { models: { ui: { headerActiveDropMenuName } } } = getState()
  const value = headerActiveDropMenuName === dropMenuName ? null : dropMenuName

  reducers.models.ui.setHeaderActiveDropMenuName(value)
}

const setHeaderSubNavDropMenuActiveIndex = (index) => reducers.models.ui.setHeaderSubNavDropMenuActiveIndex(index)
const closeAllHeaderSubNavDropMenus = () => reducers.models.ui.setHeaderSubNavDropMenuActiveIndex(null)

const hideProfileInviteBlock = () => {
  actions.misc.cookies.setItem(constants.cookieNames.isProfileInviteBlockVisible, false)
  reducers.models.ui.setProfileInviteBlockVisibility(false)
}

const hidePayPalBanner = () => {
  actions.misc.cookies.setItem(constants.cookieNames.isPayPalBannerVisible, false)
  reducers.models.ui.setPayPalBannerVisibility(false)
}

const hideImproveSurveyBanner = () => {
  actions.misc.cookies.setSessionItem(constants.cookieNames.isImproveSurveyBannerHidden, true)
  reducers.models.ui.setImproveSurveyBannerHiddenStatus(true)
}

const hideFragranceConceptsBanner = () => {
  actions.misc.cookies.setSessionItem(constants.cookieNames.isFragranceConceptsBannerHidden, true)
  reducers.models.ui.setFragranceConceptsBannerHiddenStatus(true)
}

/**
 * Hide banner
 * @param bannerName
 */
const hideBanner = (bannerName) => {
  actions.misc.cookies.setSessionItem(bannerName, true)

  reducers.models.ui.setBannerHiddenStatus(bannerName)
}

const { setClosedPopups } = reducers.models.ui

const fetchClosedPopups = () =>
  request.get('rest/popup')
    .then((result) => {
      reducers.models.ui.setClosedPopups(result)
      return result
    })

const setClosedPopup = (popupName) => {
  const { models: { ui: { closedPopups } } } = getState()

  const count = closedPopups[popupName] && closedPopups[popupName].count ? closedPopups[popupName].count + 1 : 1
  const lastUpdate = new Date()

  // Update state for quick visual response
  reducers.models.ui.setClosedPopup({ name: popupName, value: { count, lastUpdate } })

  return request.post('rest/popup', {
    body: {
      popupId: popupName,
      attributes: {
        lastUpdate,
        count,
      },
    },
  })
    .then(reducers.models.ui.setClosedPopups)
}

const resetClosedPopup = (popupName) =>
  request.post('rest/popup/reset', {
    body: {
      popupId: popupName,
    },
  })
    .then(reducers.models.ui.setClosedPopups)

/**
 * Closes all popups with a name beginning with the prefix
 * 'shippingBanner_` will close 'shippingBanner_59293', 'shippingBanner_59293', etc.
 * @param prefix
 * @return {Promise}
 */
const resetClosedPopupsByPrefix = (prefix) => {
  const { models: { ui: { closedPopups } } } = getState()

  return Promise.all(
    Object.keys(closedPopups)
      // filter names start with the prefix
      .filter((popupName) => popupName.indexOf(prefix) === 0)
      .map((popupName) => resetClosedPopup(popupName))
  )
}

const fetchResubscribeReminderPopup = () =>
  request.post('rest/resubscribe-reminder-popup')
    .then(({ popupName }) => popupName)

const fetchUnpauseModalId = () =>
  request.get('rest/unpause-popup')
    .then(({ popupName }) => popupName && parseInt(popupName.replace('popup', ''), 10)) // TODO change format on server


export default {
  showRequestLoader,
  hideRequestLoader,
  setLocale,
  openSideMenu,
  closeSideMenu,
  openProfileMenu,
  closeProfileMenu,
  toggleHeaderDropMenuVisibility,
  setHeaderSubNavDropMenuActiveIndex,
  closeAllHeaderSubNavDropMenus,
  hideProfileInviteBlock,
  hidePayPalBanner,
  hideImproveSurveyBanner,
  hideFragranceConceptsBanner,
  fetchClosedPopups,
  resetClosedPopup,
  resetClosedPopupsByPrefix,
  setClosedPopup,
  setClosedPopups,
  fetchResubscribeReminderPopup,
  fetchUnpauseModalId,
  hideBanner,
}
